import React, { Component } from "react";
import { connect } from "react-redux";
import Reaptcha from "reaptcha";

// Components
import Loader from "../utils/Loader";

// State
import { getCustomerLoginToken, customerLogin, clearErrors } from "../../store/actions/user";
import { REACT_APP_RECAPTCHA_KEY } from "../../shared/vars";

// CSS
import "../../css/errors-success.css";

class LoginForm extends Component {
	constructor(props) {
		super(props);
		this.captcha = null;
		this.state = {
			email: "",
			password: "",
			recaptchaLoaded: false
		};

		this.componentCleanup = this.componentCleanup.bind(this);
	}

	// ===================================
	//  LIFE CYCLE HOOKS
	// ===================================
	componentDidMount() {
		console.log("componentdidmount");
		window.addEventListener("beforeunload", this.componentCleanup);
		if (this.props.persisted) {
			this.performTokenSetup();
		}
	}

	shouldComponentUpdate(nextProps) {
		console.log("shouldcomponentupdate");
		if (nextProps.persisted === true && this.props.persisted === false) {
			this.performTokenSetup();
		}

		if (nextProps.maxLoginsReached !== this.props.maxLoginsReached) {
			this.setState({
				recaptchaLoaded: false
			});
		}

		return true;
	}

	performTokenSetup() {
		console.log("here at the performtokensetup.");
		this.props.getCustomerLoginToken();

		if (!this.props.maxLoginsReached) {
			this.setState({ recaptchaLoaded: true });
			console.log("set the recaptchaloaded to true so maxlogingsreached is not null");
		}
	}

	componentCleanup() {
		console.log("componentCleanup");
		this.props.clearErrors();
		window.removeEventListener("beforeunload", this.componentCleanup);
	}

	componentWillUnmount() {
		console.log("componentwillunmount");
		this.componentCleanup();
	}

	// ===================================
	//  INPUT CHANGES
	// ===================================
	handleInputChange(event) {
		event.preventDefault();
		this.setState({
			[event.target.name]: event.target.value
		});
	}

	handleKeyPress(event, item_id) {
		if (event.key === "Enter") {
			this.handleSubmit(event);
		}
	}

	recaptchChanged(value) {
		console.log("recaptchchanged");
		this.setState({
			recaptcha: value
		});
	}

	setRecaptchaLoaded(e) {
		console.log("setrecaptchaloaded");
		this.setState({
			recaptchaLoaded: true
		});
	}

	// ===================================
	//  SUBMIT
	// ===================================
	handleSubmit(event) {
		console.log("submitted the form.");
		event.preventDefault();

		if (this.props.maxLoginsReached && !this.state.recaptcha) {
			console.log("I returned and never made it to customerlogin()");
			return;
		}

		this.props
			.customerLogin(this.state.email, this.state.password, this.state.recaptcha)
			.catch(() => {
				console.log("we caught an error");
				// Reset recaptcha
				// console.log(this.captcha, this.state.recaptchaLoaded);
				if (this.captcha && this.state.recaptchaLoaded) {
					this.captcha.reset();
					this.setState({ recaptcha: null });
					console.log("caught an error in customerlogin()");
				}
			});
	}

	render() {
		const showRecaptch = this.props.maxLoginsReached;

		return (
			<form className="centered-form">
				{this.props.loginTokenLoading ? (
					<Loader />
				) : (
					<div>
						<div className="form-field no-label-field">
							<label htmlFor="email">Email:</label>

							{this.props.errors.email && (
								<div className="error msg_animate">{this.props.errors.email}</div>
							)}
							<input
								type="email"
								name="email"
								value={this.state.email}
								placeholder="email@provider.com"
								onKeyPress={e => this.handleKeyPress(e)}
								onChange={e => this.handleInputChange(e)}
								disabled={!this.state.recaptchaLoaded}
							/>
						</div>
						<div className="form-field no-label-field">
							<label htmlFor="password">Password:</label>

							{this.props.errors.password && (
								<div className="error msg_animate">
									{this.props.errors.password}
								</div>
							)}
							<input
								type="password"
								name="password"
								value={this.state.password}
								placeholder="Enter password"
								onKeyPress={e => this.handleKeyPress(e)}
								onChange={e => this.handleInputChange(e)}
								disabled={!this.state.recaptchaLoaded}
							/>
						</div>

						{showRecaptch && (
							<Reaptcha
								ref={e => (this.captcha = e)}
								sitekey={REACT_APP_RECAPTCHA_KEY}
								onVerify={value => this.recaptchChanged(value)}
								onLoad={() => this.setRecaptchaLoaded()}
							/>
						)}

						<div className="btn_container">
							{this.props.errors.general && (
								<div className="error msg_animate">{this.props.errors.general}</div>
							)}
							<button
								className="btn submit-btn"
								name="submit"
								value="submit"
								onClick={e => this.handleSubmit(e)}
								disabled={showRecaptch ? !this.state.recaptcha : false}
							>
								<span>Log In</span>
							</button>
						</div>
					</div>
				)}
			</form>
		);
	}
}

const mapStateToProps = state => {
	return {
		persisted: state.persist,
		errors: state.user.errors,
		loginTokenLoading: state.user.loginTokenLoading,
		maxLoginsReached: !!state.user.maxLoginsReached.customer
			? state.user.maxLoginsReached.customer
			: false
	};
};

export default connect(
	mapStateToProps,
	{ getCustomerLoginToken, customerLogin, clearErrors }
)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/customer/LoginForm.js